import kbpgp from 'kbpgp'
import {promisify} from 'utils/promise.utils'
import createKeyManager from './createKeyManager'

export default async ({keyManager, keys, passphrase, armored}) => {
  const keyfetch = keyManager || (await createKeyManager(keys, passphrase))
  const literals = await promisify(kbpgp.unbox, kbpgp)({armored, keyfetch})
  return literals[0].toString()
}
